import axios from 'axios';
let input = document.querySelectorAll('#xsrf input')[0];

var instance = axios.create({
  baseURL: '/api/v1/',
  timeout: 60000,
  // headers:{'Access-Control-Allow-Origin': '*'}
  // headers: { 'X-XSRF-Token-App': input !== undefined ? input.value : 'none'}
});

instance.interceptors.response.use(function(response) {
  return response.data.result;
}, function(error) {
  console.warn('$store response error interceptor hit');
  return Promise.reject(error);
});

export default instance;
